import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
}

export const ModalConfirmRestore = ({
  open,
  setOpen,
  onConfirm,
  title = 'Confirmar Restauración',
  description = '¿Está seguro de restaurar este registro? El estado pasará a activo nuevamente.',
}: Props) => {
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: { borderRadius: 3, minWidth: 420 },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ m: 1, p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              minWidth: 48,
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: '#E4F6D6',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <RestoreOutlinedIcon color="success" />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.2 }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ px: 3, py: 3, borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0' }}
      >
        <Box
          sx={{
            backgroundColor: '#F6FCEF',
            borderRadius: 2,
            p: 2,
            display: 'flex',
            gap: 1.5,
            alignItems: 'flex-start',
            border: '1px solid #E4F6D6',
          }}
        >
          <InfoOutlinedIcon sx={{ color: '#2e7d32', fontSize: 22, flexShrink: 0 }} />
          <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 500, lineHeight: 1.5 }}>
            {description}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2, pb: 2 }}>
        <Button
          onClick={handleClose}
          color="inherit"
          variant="outlined"
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="success"
          variant="contained"
          autoFocus
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3, boxShadow: 'none' }}
        >
          Restaurar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
